import MeuPedagioLogo from "src/assets/images/partners/meupedagio/logos/logo.svg";
import MeuPedagioLogoDark from "src/assets/images/partners/meupedagio/logos/logo_dark.svg";
import MeuPedagioLogoLight from "src/assets/images/partners/meupedagio/logos/logo_light.svg";
import MeuPedagioMinLogo from "src/assets/images/partners/meupedagio/logos/min-logo.svg";

import Error400 from "src/assets/images/partners/meupedagio/error-400.svg"
import Error404 from "src/assets/images/partners/meupedagio/error-404.svg"
import ConfirmEmailImage from "src/assets/images/partners/meupedagio/confirm-email.svg"
import GoodbyeImage from "src/assets/images/partners/meupedagio/goodbye.svg"


export enum WhitelabelHookType {
    LOGO = 'logo',
    MIN_LOGO = 'minLogo',
    DASH_TITLE = 'dashTitle',
    ERROR_400 = 'error400',
    ERROR_404 = 'error404',
    CONFIRM_EMAIL = 'confirmEmail',
    IS_PARTNER = 'isPartner',
    TITLE = 'title',
    ONBOARDING_STEP1_CONGRATULATIONS = 'onboardingStep1Congratulations',
    ONBOARDING_STEP2_CREDIT_CARD = 'onboardingStep2CreditCard',
    CNPJ = 'cnpj',
    GOODBYE = 'goodbye',
}

export default function useWhitelabel(type: WhitelabelHookType, variant: "light" | "dark" | "default" = "default") {
    // const clientId = import.meta.env.VITE_APP_CLIENT_ID;
    switch (type) {
        case WhitelabelHookType.LOGO:
            switch (variant) {
                case 'light':
                    return MeuPedagioLogoLight;
                case 'dark':
                    return MeuPedagioLogoDark;
                default:
                    return MeuPedagioLogo;
            }
        case WhitelabelHookType.MIN_LOGO:
            return MeuPedagioMinLogo;
        case WhitelabelHookType.DASH_TITLE:
        case WhitelabelHookType.TITLE:
            return "Meu Pedágio";
        case WhitelabelHookType.ERROR_400:
            return Error400;
        case WhitelabelHookType.ERROR_404:
            return Error404;
        case WhitelabelHookType.CONFIRM_EMAIL:
            return ConfirmEmailImage;
        case WhitelabelHookType.IS_PARTNER:
            return `${false}`;
        case WhitelabelHookType.CNPJ:
            return "51.111.347/0001-42";
        case WhitelabelHookType.GOODBYE:
            return GoodbyeImage;
    }
}